export const TOGGLE_LOVE = 'TOGGLE_LOVE';
export const PROOF_ITEM_HOVER = 'PROOF_ITEM_HOVER';
export const PROOF_ITEM_SELECT = 'PROOF_ITEM_SELECT';
export const PROOF_MODE_CHANGE = 'PROOF_MODE_CHANGE';


// WEBPACK FOOTER //
// ./constants/actionTypes.js